/**
 *
 * JobsPage (CP'd from VoiceModelsPage for redux stuff)
 *
 */
// @ts-nocheck
import * as React from 'react';
import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {Helmet} from 'react-helmet-async';
import '../InferPage/Infer.css';
import {useNavigate, useOutletContext} from "react-router-dom";
import {motion} from "framer-motion";
// REDUX SLICE imports
import {useJobsSlice} from "app/pages/JobsPage/slice";
import {Api} from "../../../store/api";
import useUserObject from "app/hooks/useUserObject";
import {media} from "../../../styles/media";
import Container from "@mui/material/Container";
import {PricingTable} from "app/pages/UpgradePage/pricingTable";
import {SwapVoiceFaqsContent, PricingFaqsContent} from "app/pages/FaqsPage";
import { useFeatureFlagVariantKey } from 'posthog-js/react'


interface Props {}

export function UpgradePage(props: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useUserObject();
  const [userProfile] = useOutletContext();
  let email = user["email"];
  const { actions } = useJobsSlice();


  const [isRedirectingToCreatorPlan, setIsRedirectingToCreatorPlan] = useState(false);

  const posthogPricingTitleVariant = useFeatureFlagVariantKey('pricing-title-change');
  const posthogPricingSubtitleVariant = useFeatureFlagVariantKey('pricing-subtitle-change');

  // Navigate to TrainingPage on click "Create New Voice"
  const handleCreateNewVoice = () => {
    navigate('/train');
  }

    useEffect(() => {
        return () => {
            // Track tiktok event
            // @ts-ignore
            window.ttq.track('ViewContent', {
                content_type: 'product_group',
                content_id: 'upgrade',
            })


        };
    }, []);



  const handleClickTrial = () => {
    // Track tiktok event
    // @ts-ignore
    window.ttq.track('InitiateCheckout', {
        content_type: 'product',
        content_id: 'trial-plan',
        content_name: 'Trial Plan',
        currency: 'USD',
        price: '10.00',
        quantity: 1,
        value: '10.00',
    })
    Api.redirectToTrialCheckout()
  }

  const isCreator = userProfile?.plan?.includes('creator')
  const isStarter = userProfile?.plan?.includes('starter')
    // Creators should not see this page
    if (isCreator) {
        navigate('/app/voice-models')
    }

  return (
    <>
      <Helmet>
        <title>ControllaVoice Upgrade</title>
        <meta
          name="Controlla Voice"
          content="Generate and transform vocals using AI"
        />
      </Helmet>
      <div style={{overflowY: 'auto', height: 'calc(100dvh - 90px)'}}>
        {!isLoading && (
          <MotionContent
              initial={{translateY: '100px', opacity: 0}}
              animate={{translateY: "0px", opacity: 1}}
              exit={{translateY: "0px", opacity: 0}}
              transition={{duration: 0.5}}
          >
              <VoiceModelPageTitleAction>
                  <h2>{posthogPricingTitleVariant === 'new-title' ? 'Claim Your Creative Power' : 'Unleash your voice today!'}</h2>
                  <h3 style={{ marginBottom: '0px', fontSize: '18px' }}>
                    {posthogPricingSubtitleVariant === 'new-subtitle'
                      ? 'Unlock powerful tools today—get first access to the next wave of music innovation. From studio-grade voice swap to AI song generation and stem split, everything you need to craft your best sound is just beginning'
                      : 'Flexible plans to fit your needs, cancel anytime.'}
                  </h3>
              </VoiceModelPageTitleAction>
              <Container sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                  <PricingTable creator={isCreator} starter={isStarter} isCheckboxSelectMode={false} hideFreePlan={true} hideContractCard={false} small={false} />
              </Container>
              <h2>FAQs</h2>
              <PricingFaqsContent />
              <SwapVoiceFaqsContent />
              <br />
          </MotionContent>
        )}
      </div>
    </>
  );
}

const Content = styled.div `
  max-width: 1200px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
`;

const MotionContent = motion(Content);

const VoiceModelPageTitleAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
`;

const VoiceModelPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-bottom: 80px;
  align-items: center;

  
  ${media.small} {
    flex-direction: row;
  }
`;
